import { MessageTemplateList } from "./MessageTemplateList";

export default {
  list: MessageTemplateList,
};
